<header mat-dialog-title class="u-flex-full">
  <span>
    {{'risks.Seleziona area' | translate}}
  </span>
</header>
<mat-dialog-content>
  <risk-owner-list [riskOwners]="riskOwners" [defaultFilters]="defaultFilters" [displayedColumns]="displayedColumns" [total]="total"
    [canSelect]="true" (onSortChange)="sortChange($event)" (onPageChange)="pageChange($event)"
    (onFilterChange)="filtersChange($event)" (onSelectRiskOwner)="selectRiskOwner($event)"></risk-owner-list>
</mat-dialog-content>
<mat-dialog-actions class="u-flex-full">
  <span>
  </span>
  <button mat-raised-button color="basic" type="button" (click)="close()">{{'shared.Chiudi' | translate}}</button>
</mat-dialog-actions>
